// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat_tab___-Ug- {\n  flex: 2;\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 40px);\n}", ""]);
// Exports
exports.locals = {
	"tab": "chat_tab___-Ug-"
};
module.exports = exports;
